"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRINTER_DPIS = exports.PrinterLanguage = exports.PrinterConnexion = exports.PrinterTypes = void 0;
var PrinterTypes;
(function (PrinterTypes) {
    PrinterTypes["CASH_REGISTER"] = "cash_register";
    PrinterTypes["DELIVERY"] = "delivery";
    PrinterTypes["COOK"] = "cook";
    // Imprimante d'ÉTIQUETTES « à coller » sur les produits : une étiquette par
    // unité, tirée quand la ligne est validée sur le KDS (Maxence, 5 oct. 2026).
    PrinterTypes["PRODUCT"] = "product";
})(PrinterTypes || (exports.PrinterTypes = PrinterTypes = {}));
var PrinterConnexion;
(function (PrinterConnexion) {
    PrinterConnexion["ETHERNET"] = "ethernet";
    // USB = 'usb',
})(PrinterConnexion || (exports.PrinterConnexion = PrinterConnexion = {}));
// Langage de l'imprimante (5 oct. 2026) : ESC/POS pour les tickets, ZPL pour
// les Zebra à étiquettes — réservé à l'usage « Produit ». Absent = ESC/POS.
var PrinterLanguage;
(function (PrinterLanguage) {
    PrinterLanguage["ESCPOS"] = "escpos";
    PrinterLanguage["ZPL"] = "zpl";
})(PrinterLanguage || (exports.PrinterLanguage = PrinterLanguage = {}));
/** Les résolutions des Zebra du marché. */
exports.PRINTER_DPIS = [203, 300, 600];
